import { ConditionalView } from "../ConditionalView";
import { RenderStateViewProps } from "./RenderStateView.types";
import { usePresenter } from "./usePresenter";

const RenderStateView = <T = unknown, P = any>(props: RenderStateViewProps<T, P>) => {
  const { 
    data, 
    isLoading,
    errorData,
    filled: Filled, 
    empty: Empty, 
    loading: Loading,
    error: Error,
    ...rest
  } = props;
  const { showError, showLoading, showEmpty, showFilled } = usePresenter(props);

  return (
    <>
      <ConditionalView condition={showError}>
        {Error && <Error error={errorData as Error | string} {...rest as any} />}
      </ConditionalView>

      <ConditionalView condition={showLoading}>
        {Loading && <Loading {...rest as any} />}
      </ConditionalView>

      <ConditionalView condition={showEmpty}>
        {Empty && <Empty {...rest as any} />}
      </ConditionalView>

      <ConditionalView condition={showFilled}>
        {Filled && <Filled data={data as T} {...rest as any} />}
      </ConditionalView>
    </>
  );
};

export default RenderStateView;
